import React from 'react';

import ArchivesPromotionImage from '../../../assets/ArchivesPageBanners/Venus-berline-promo-banner.jpg';

import styles from './css/ArchivesPromotionBanner.module.css';


function ArchivesPromotionBanner(props) {
  const { affiliatePartnerCode } = props;
  const redirectURL = `/account/purchase?promoCode=${affiliatePartnerCode}`;

  if (!affiliatePartnerCode) {
    return null;
  }

  return (
    <div className="container">
      <a className={styles.banner} href={redirectURL}>
        <img alt="special-promotion" className={styles.banner} src={ArchivesPromotionImage} />
      </a>
    </div>
  );
}

export default ArchivesPromotionBanner;
